import React, { Component } from 'react'
import axios from 'axios'
import { CSNEW_API_URL } from '../lib/env'
import SalesDealItemOpa from '../components/sales_deal_item_opa'
import { Button, Tabs, Tab } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import ClearIcon from '@material-ui/icons/Clear'
import Typography from '@material-ui/core/Typography'
import Slide from '@material-ui/core/Slide'
import Box from '@material-ui/core/Box'
import SaleOpa from '../components/sale_opa'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import InputMask from 'react-input-mask'
import Chip from '@material-ui/core/Chip'
import LinearProgress from '@material-ui/core/LinearProgress'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import FieldInfo from '../asterX-UIkit/DisplayData/FieldInfo'
import {
  ACTIVE,
  HOLD,
  ISSUE,
  LOGIST,
  MISSED,
  PAYMENT,
  SUCCESS
} from '../constants/stuses'
import ErrorModal from '../asterX-UIkit/modals/ErrorModal'

class SalesListOpa extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sales: [],
      selectedSale: null,
      filterId: '',
      filterPhone: '',
      filterName: '',
      filterSurname: '',
      loading: false,
      error: false,
      selectedTab: 0
    }
  }

  handleChangeTab(event, selectedTab) {
    this.setState(
      {
        sales: [],
        selectedSale: null,
        filterId: '',
        filterPhone: '',
        filterName: '',
        filterSurname: '',
        loading: false,
        selectedTab: selectedTab
      },
      () => this.getSales()
    )
  }

  componentDidMount() {
    this.getSales()
  }

  getSales() {
    const self = this

    let searchData = {
      limit: 10,
      offset: 0
    }

    if (this.state.filterId !== '') {
      searchData = { id: this.state.filterId, ...searchData }
    }

    if (this.state.filterPhone !== '') {
      searchData.client = {
        phoneNumber: this.state.filterPhone,
        ...searchData.client
      }
    }

    if (this.state.filterName !== '') {
      searchData.client = {
        firstName: this.state.filterName,
        ...searchData.client
      }
    }

    if (this.state.filterSurname !== '') {
      searchData.client = {
        lastName: this.state.filterSurname,
        ...searchData.client
      }
    }

    if (this.state.selectedTab === 0) {
      searchData.saleStatusTrackCode = 20
    } else if (this.state.selectedTab === 1) {
      searchData.saleStatusTrackCode = 30
    }

    this.setState({ loading: true })
    axios
      .post(CSNEW_API_URL + '/sales/list', searchData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(function (response) {
        let data = response.data
        console.log(data)
        self.setState({ sales: response.data.listSales })
        self.setState({ loading: false })
      })
      .catch(function (error) {
        self.setState({ loading: false })
      })
  }

  selectSale(saleId) {
    axios
      .get(`${CSNEW_API_URL}/sales/getById/${saleId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(response => {
        console.log(response.data)
        this.setState({ selectedSale: response.data })
      })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleSearch() {
    this.getSales()
  }

  handleComplete() {
    let self = this
    axios
      .patch(
        `${CSNEW_API_URL}/salesStatus/updateStatusTrack`,
        {
          saleId: self.state.selectedSale.id,
          status: 40
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then(response => {
        console.log(response.data)
        this.props.history.push('/')
      })
  }

  handleResetFilter() {
    this.setState({
      sales: [],
      selectedSale: null,
      filterId: '',
      filterPhone: '',
      filterName: '',
      filterSurname: '',
      loading: false
    })
  }

  render() {
    return (
      <div>
        <div
          className="btn-calc"
          style={{ marginBottom: '10px', alignItems: 'center' }}
        >
          <Button
            className="button_small button_grey_color"
            variant="contained"
            color="primary"
            style={{ marginRight: '10px' }}
            onClick={() => this.props.history.push('/')}
          >
            Назад
          </Button>
          <span style={{ fontSize: '18px', fontWeight: 900 }}>РЛ ОПА</span>
        </div>
        <div style={{ marginBottom: '10px', alignItems: 'center' }}>
          <Tabs
            value={this.state.selectedTab}
            onChange={this.handleChangeTab.bind(this)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Очередь" />
            <Tab label="На консультации" />
            <Tab label="Все" />
          </Tabs>
        </div>
        {this.state.loading && <LinearProgress />}

        <TabPanel value={this.state.selectedTab} index={0}>
          {this.state.sales?.map(sale => (
            <SalesDealItemOpa
              key={`deal-${sale.id}`}
              deal={sale}
              selectedTab={this.state.selectedTab}
              showStatus={true}
              openButtonContent={'Новый контакт'}
              onClick={this.selectSale.bind(this, sale.id)}
            />
          ))}
        </TabPanel>

        <TabPanel value={this.state.selectedTab} index={1}>
          {this.state.sales?.map(sale => (
            <SalesDealItemOpa
              key={`deal-${sale.id}`}
              deal={sale}
              selectedTab={this.state.selectedTab}
              showStatus={true}
              openButtonContent={'Новый контакт'}
              onClick={this.selectSale.bind(this, sale.id)}
            />
          ))}
        </TabPanel>

        <TabPanel value={this.state.selectedTab} index={2}>
          <Box className="paper_green_bg" display="flex" mt={1}>
            <Box display="flex" flexWrap={'wrap'}>
              <Box width={150} mr={1}>
                <TextField
                  label={'Номер РЛ'}
                  margin="normal"
                  fullWidth
                  style={{ fontWeight: '700' }}
                  name={'filterId'}
                  value={this.state.filterId}
                  onChange={this.handleChange('filterId')}
                />
              </Box>
              <Box width={150} mr={1}>
                <TextField
                  label={'Имя'}
                  margin="normal"
                  fullWidth
                  style={{ fontWeight: '700' }}
                  name={'filterName'}
                  value={this.state.filterName}
                  onChange={this.handleChange('filterName')}
                />
              </Box>
              <Box width={150} mr={1}>
                <TextField
                  label={'Фамилия'}
                  margin="normal"
                  fullWidth
                  style={{ fontWeight: '700' }}
                  name={'filterSurname'}
                  value={this.state.filterSurname}
                  onChange={this.handleChange('filterSurname')}
                />
              </Box>
              <Box width={150} mr={1} mt={2}>
                <InputMask
                  mask={'8 (999) 999-99-99'}
                  value={this.state.filterPhone}
                  maskChar={'_'}
                  onChange={this.handleChange('filterPhone')}
                >
                  {inputProps => (
                    <TextField
                      label="Телефон"
                      InputProps={{
                        ...inputProps
                      }}
                      type="tel"
                    />
                  )}
                </InputMask>
              </Box>
              <Box mt={2} mr={1}>
                <Button
                  className="button_small button_green_color"
                  style={{ marginTop: '10px', paddingLeft: '10px' }}
                  color="primary"
                  variant="contained"
                  onClick={this.handleSearch.bind(this)}
                >
                  <SearchIcon
                    style={{ fontSize: '18px', marginRight: '5px' }}
                  />
                </Button>
              </Box>
              <Box mt={2} mr={1}>
                <Button
                  className="button_small button_grey_color"
                  style={{
                    marginTop: '10px',
                    paddingLeft: '10px',
                    backgroundColor: '#ff5733 ',
                    color: '#FFF'
                  }}
                  onClick={this.handleResetFilter.bind(this)}
                  variant="contained"
                >
                  <ClearIcon style={{ fontSize: '18px' }} />
                </Button>
              </Box>
            </Box>
          </Box>

          {this.state.sales?.map(sale => (
            <SalesDealItemOpa
              key={`deal-${sale.id}`}
              deal={sale}
              selectedTab={this.state.selectedTab}
              showStatus={true}
              openButtonContent={'Новый контакт'}
              onClick={this.selectSale.bind(this, sale.id)}
            />
          ))}
        </TabPanel>

        {this.state.selectedSale && (
          <Dialog
            fullScreen
            open={this.state.selectedSale}
            TransitionComponent={Transition}
          >
            <AppBar
              style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => this.setState({ selectedSale: null })}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6">Информация о клиенте</Typography>
              </Toolbar>
            </AppBar>
            <Box style={{ marginTop: '80px' }}>
              <div
                style={{
                  fontWeight: '900',
                  fontSize: '22px',
                  marginLeft: '10px',
                  marginTop: '10px'
                }}
              >
                {this.state.selectedSale.client.firstName}{' '}
                {this.state.selectedSale.client.lastName}
                {![MISSED, SUCCESS].includes(
                  this.state.selectedSale?.saleStatus?.code
                ) &&
                  this.state.selectedSale?.saleStatusTrack?.trackStatus
                    ?.code === 30 && (
                    <Button
                      variant="outlined"
                      className="button_small button_green_color"
                      onClick={this.handleComplete.bind(this)}
                      style={{ marginLeft: 12 }}
                    >
                      Завершить консультацию
                    </Button>
                  )}
              </div>
              <Box ml={2}>
                <FieldInfo
                  label={'Cтатус :'}
                  value={
                    this.state.selectedSale?.saleStatusTrack?.trackStatus
                      ?.name || ''
                  }
                />
              </Box>
              <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                ID: {this.state.selectedSale.id}
              </div>
              {this.state.selectedSale.saleStatus &&
                this.state.selectedSale.saleStatus.code === 'HOLD' && (
                  <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                    <Chip size="small" label="В работе" />
                  </div>
                )}
              {(!this.state.selectedSale.saleStatus ||
                this.state.selectedSale.saleStatus.code === 'ACTIVE') && (
                <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                  <Chip size="small" label="Активный контакт" />
                </div>
              )}
              {this.state.selectedSale.saleStatus &&
                this.state.selectedSale.saleStatus.code === 'PAYMENT' && (
                  <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                    <Chip size="small" label="На оформлении" />
                  </div>
                )}
              <div className="paper-nohover" style={{ marginTop: '10px' }}>
                <SaleOpa
                  sale={this.state.selectedSale}
                  seoNumber={this.props.location.state.seoNumber}
                />
              </div>
            </Box>
          </Dialog>
        )}
        <ErrorModal
          e={this.state.error}
          close={() => this.setState({ error: false })}
          snackbar={true}
        />
      </div>
    )
  }
}

export default flowRight(withSnackbar)(SalesListOpa)

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
